import { ENTELIOS_PORTFOLIO_IDENTIFIER } from '@/features/bidding/constants'
import type { AggregatedBidPtu } from '@/features/bidding/utils/model/buildAggregatedBid'
import type { AggregatedBidWrapper } from '@/features/bidding/utils/model/mapActivationGroupBidsToAggregatedBids'

export function getUniquePricesFromAllActivationGroups(
  ptu: AggregatedBidPtu,
  bidsPerActivationGroup: Map<string, AggregatedBidWrapper>,
): number {
  const uniquePrices = new Set<number>()

  for (const otherBidWrapper of bidsPerActivationGroup.values()) {
    const otherPtu = otherBidWrapper.aggregatedBid.ptus.find((p) => p.ptuStart.equals(ptu.ptuStart))
    if (otherPtu) {
      otherPtu.priceQuantities.filter((pq) => pq.quantity !== 0).forEach((pq) => uniquePrices.add(pq.price))
    }
  }

  return uniquePrices.size
}

export function getCountOfNonZeroPriceQuantities(ptu: AggregatedBidPtu): number {
  return ptu.priceQuantities.filter((pq) => pq.quantity !== 0).length
}

export function isPortfolioEntelios(portfolioCode?: string): boolean {
  return portfolioCode?.toUpperCase().includes(ENTELIOS_PORTFOLIO_IDENTIFIER) ?? false
}
